import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";

const highlights = [
  {
    title: "Fast Loading",
    description: "Google AMP and performance-optimized layouts for instant page loads.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M13 2L4.5 13.5H11L10 22L19.5 10.5H13V2Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Mobile Responsive",
    description: "Flawless experience across every screen size and device type.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 18h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "SEO Friendly",
    description: "Clean structure and semantic markup built for search visibility.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 18V8M4 18h16M8 14V11M12 14V6M16 14V9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Custom Design",
    description: "No templates — every website tailored to your unique business.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 5h16v14H4V5Z" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 9h16M8 13h8M8 17h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
];

const WdesignIntroSection: React.FC = () => {
  return (
    <section className="wdev-intro" aria-labelledby="wdesign-intro-title">
      <div className="container">
        <div className="wdev-intro__grid">
          <AnimatedSection className="wdev-intro__content">
            <span className="wdev-label wdev-label--purple">Website Design</span>
            <h2 id="wdesign-intro-title" className="wdev-intro__title">
              Best Website Designer for Fast Loading Web Design
            </h2>

            <p className="wdev-intro__text">
              WebTech Software Solutions is one of the best fast loading and mobile
              responsive web designing companies in Bangalore, India. Our journey
              started in 2015 — now we are super-specialized in advanced Google AMP
              mobile website technologies and progressive web app development.
            </p>
            <p className="wdev-intro__text">
              We understand your business nature, potential user behaviours, keywords,
              and search phrases to customize a mobile-friendly website. There is no
              one template that fits all businesses — every business is unique and its
              website needs to be so.
            </p>

            <div className="wdev-intro__highlights">
              {highlights.map((item) => (
                <div className="wdev-intro__highlight" key={item.title}>
                  <div className="wdev-intro__highlight-icon">{item.icon}</div>
                  <div>
                    <h3 className="wdev-intro__highlight-title">{item.title}</h3>
                    <p className="wdev-intro__highlight-desc">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </AnimatedSection>

          <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
            <EstimateProjectForm />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default WdesignIntroSection;
